import React from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Stack,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { SalesforceSettingsView } from "../../views/SalesforceSettingsView";
import { useSalesforceIntegrationDetailsContext } from "../../contexts/useSalesforceIntegrationDetailsContext";
import { EnrichmentSynchronizationState } from "../../types";
import { lightScrollbarStyle } from "../../../../styles/lightScrollbarStyle";
import { SalesforceSettingsActions } from "./SalesforceSettingsActions";

export const SalesforceSettingsModal: React.FC = () => {
  const {
    synchronizationState,
    integration,
    isSettingsModalOpen,
    setIsSettingsModalOpen,
  } = useSalesforceIntegrationDetailsContext();

  // Compute isInitialSetup locally
  const isInitialSetup =
    synchronizationState === EnrichmentSynchronizationState.NEVER_RAN_MATCHING;

  const handleClose = () => {
    if (!isInitialSetup) {
      setIsSettingsModalOpen(false);
    }
  };

  return (
    <Dialog
      data-testid="salesforce-settings-modal"
      open={isSettingsModalOpen}
      maxWidth="xs"
      aria-labelledby="integration-settings-modal"
      slotProps={{
        backdrop: {
          sx: {
            backdropFilter: "blur(5px)",
          },
        },
      }}
      disableEscapeKeyDown
    >
      <DialogTitle>
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
        >
          <Typography variant="h4" fontWeight="bold">
            Sync Settings
          </Typography>
          {!isInitialSetup && (
            <IconButton
              data-testid="salesforce-settings-close-btn"
              onClick={handleClose}
              size="small"
            >
              <CloseIcon fontSize="small" />
            </IconButton>
          )}
        </Stack>
        <Typography variant="body2" color="text.secondary">
          Configure {integration.name} integration
        </Typography>
      </DialogTitle>

      <DialogContent sx={{ ...lightScrollbarStyle }}>
        <SalesforceSettingsView />
      </DialogContent>
      <DialogActions sx={{ paddingY: 2, paddingX: 2 }}>
        <SalesforceSettingsActions />
      </DialogActions>
    </Dialog>
  );
};
